import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";

const CommonDatePickerReports = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  const { pathname } = useLocation();

  const pathArr = ["/sites-view"];
  return (
    <>
      <div className={`col-md-2 ${pathArr.includes(pathname) ? "mt-4" : ""}`}>
        <label className="form-label">From Date*</label>
        <DatePicker
          selected={fromDate}
          onChange={(date) => setFromDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select from date"
          maxDate={toDate}
        />
      </div>

      {/* To Date */}
      <div className={`col-md-2 ${pathArr.includes(pathname) ? "mt-4" : ""}`}>
        <label className="form-label">To Date*</label>
        <DatePicker
          selected={toDate}
          onChange={(date) => setToDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select to date"
          minDate={fromDate} // prevent selecting before fromDate
          maxDate={new Date()}
        />
      </div>
    </>
  );
};

export default CommonDatePickerReports;
